import React, { useState ,useEffect} from 'react';
import {
    FaHome,
    FaBars,
    FaWhmcs,
    FaBell,
    FaUserAlt
} from "react-icons/fa";
import { TeamOutlined, DashboardOutlined, CheckCircleOutlined, AntCloudOutlined, BookOutlined, RiseOutlined, DashboardFilled, BellOutlined, CloudSyncOutlined, BugOutlined } from "@ant-design/icons";
import { AiOutlineDotChart } from "react-icons/ai";
import { NavLink } from 'react-router-dom';
import logoImg from '../../assets/images/MizuWatch.png';
import logoImgs from '../../assets/images/MizuSmart_.png';
import activeAccountSettings from '../../assets/images/icons/activeAccountSettings.svg';
import activeUsage from '../../assets/images/icons/active-usage.svg';
import activeAnalytics from '../../assets/images/icons/activeAnalytics.svg';
import activeHome from '../../assets/images/icons/activeHome.svg';
import activeMiscellaneous from '../../assets/images/icons/activeMiscellaneous.svg';
import activeSchematics from '../../assets/images/icons/activeSchematics.svg';
// import activeAccountSettings from '../../assets/images/icons/activeAccountSettings.svg';
import analytics from '../../assets/images/icons/analytics.svg';
import home from '../../assets/images/icons/home.svg';
import miscellaneous from '../../assets/images/icons/miscellaneous.svg';
import schematics from '../../assets/images/icons/schematics.svg';
import usage from '../../assets/images/icons/usage.svg';
// import accountSettings from '../../assets/images/icons/accountSettings.svg';
import ActSettings from '../../assets/images/icons/actSettings.svg';
import ActiveSettings from '../../assets/images/icons/activeSettings.svg';

import { get } from "../../Libraries/Ajax/HttpService";

const Sidenav = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const [datastatusaccontability, setDatastatusaccountability] = useState(false);
    const [datastatusanomaly, setDatastatusanomaly] = useState(false);
    var data = JSON.parse(localStorage.getItem("MCData"));
    
    //     settings_page_view - false - settings page view permissions

    // registration_view
    const pathNameLink = window.location.pathname
    const menuItem = [
        {
            path: "/dashboard",
            name: "Home",
            icon: <FaHome />
        },
        {
            path: "/Waters",
            name: "Water",
            icon: <AntCloudOutlined />
        },
        {
            path: "/settings",
            name: "Setting",
            icon: <FaWhmcs />
        },
        {
            path: "/notification",
            name: "Dashboard",
            icon: <DashboardFilled />
        },
        {
            path: "/accountnames",
            name: "Account Name",
            icon: <TeamOutlined />
        },
        {
            path: "/outliers",
            name: "Outliers",
            icon: <CheckCircleOutlined />
        },
        {
            path: "/devices",
            name: "Devices",
            icon: <DashboardOutlined />
        },
        {
            path: "/accountstats",
            name: "AccountStats",
            icon: <BookOutlined />
        },
        {
            path: "/totalflow",
            name: "Total Flow",
            icon: <RiseOutlined />
        },
        {
            path: "/registration",
            name: "Registration",
            icon: <FaUserAlt />
        },

    ]
    useEffect(() => {
        var user = JSON.parse(localStorage.getItem("MCData"));
        var userid = user?.userid;
       
            get(`apis/alert_status?user_id=${userid}`).then(
                (response) => {
                    console.log(response.data.data.accountability_alert_status);
                    setDatastatusaccountability(response.data.data.accountability_alert_status);
                    setDatastatusanomaly(response.data.data.anomaly_alert_status);
                   
                 }
            );
    },[datastatusaccontability],[datastatusanomaly]
    )
    return (
        <div>
           
            <div className="container-fluid ph-sidebar">
                <div style={{ width: isOpen ? "220px" : "90px" }} className="sidebar">
                    {data.mcdatas.registration_view === true && data.mcdatas.settings_page_view === true ? <>
                        <div className="top_section">
                            <div style={{ display: isOpen ? "block" : "none" }} className="logo"> {window.location.hostname === "mizuwatch.com" ? <img src={logoImg} className="img-fluid" alt="McCord Logo Image" /> : <img src={logoImgs} className="img-fluid" alt="McCord Logo Image" />} </div>
                            <div style={{ marginLeft: isOpen ? "15px" : "0px" }} className="bars">
                                <FaBars onClick={toggle} />
                            </div>
                        </div>
                      
                        {/* <NavLink className="link" activeClassName="active" to="/dashboard" title="Home">
                            <div className="icon"><FaHome /></div>
                            <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Home</div>
                        </NavLink> */}
                          {/* home */}
                          {pathNameLink === '/dashboard' ?
                                <NavLink className="link" activeClassName="active" to="/dashboard" title="Home" style={{background: '#1998f0'}}>
                                    <div className="icon">
                                        <img src={activeHome} alt="" />
                                    </div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis text-white"> Home</div>
                                </NavLink>
                                :
                                <NavLink className="link" activeClassName="active" to="/dashboard" title="Home">
                                    <div className="icon">
                                         <img src={home} alt="" /></div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Home</div>
                                </NavLink>
                            }
                        {/* home */}
                        {/* {pathNameLink === '/Wateragg' ?
                        <NavLink className="link" activeClassName="active" to="/Wateragg" title="Water Usage">
                            <div className="icon"><AntCloudOutlined /></div>
                            <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Water Usage </div>
                        </NavLink>: <NavLink className="link" activeClassName="active" to="/Waters" title="Water Usage">
                            <div className="icon"><AntCloudOutlined /></div>
                            <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Water Usage</div>
                        </NavLink>} */}
                        {/*  */}
                         {/* Waters */}
                         {pathNameLink === '/Waters' || pathNameLink === '/Wateragg' || pathNameLink === '/watermeterreadings'?
                                <NavLink className="link" activeClassName="active" to="/Waters" title="Water Usage" style={{background: '#1998f0'}}>
                                   
                                    <div className="icon">
                                        <img src={activeUsage} alt="" />
                                    </div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis text-white"> Water Usage</div>
                                </NavLink>
                                :
                                <NavLink className="link" activeClassName="active" to="/Waters" title="Water Usage">
                                    <div className="icon">
                                         <img src={usage} alt="" /></div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Water Usage</div>
                                </NavLink>
                            }
                        {/* Waters */}
                        {/*  */}
                        {/* <NavLink className="link" activeClassName="active" to="/totalflow" title="Analytics">
                            <div className="icon"><RiseOutlined /></div>
                            <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Analytics</div>
                        </NavLink> */}
                         {/* Analytics */}
                         {pathNameLink === '/totalflow' || pathNameLink === '/predictiveanalysis' || pathNameLink === '/Anomaly' ?
                                <NavLink className="link" activeClassName="active" to="/totalflow" title="Analytics" style={{background: '#1998f0'}}>
                                    <div className="icon">
                                        <img src={activeAnalytics} alt="" />
                                    </div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis text-white"> Analytics</div>
                                </NavLink>
                                :
                                <NavLink className="link" activeClassName="active" to="/totalflow" title="Analytics">
                                    {datastatusaccontability=== true || datastatusanomaly=== true ?
                                     <div className="notif-style">
                                        {/* <p>
                                        <ExclamationOutlined />
                                        </p> */}
                                    </div>:""}
                                    <div className="icon">
                                         <img src={analytics} alt="" /></div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Analytics</div>
                                </NavLink>
                            }
                        {/* Analytics */}
                        {/* {pathNameLink === '/stats' ?
                            <NavLink className="link" activeClassName="active" to="/stats" title=" Digital Twin">
                                <div className="icon"><DashboardOutlined /></div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Digital Twin</div>
                              
                            </NavLink>
                            : pathNameLink === '/devices' ?
                                <NavLink className="link" activeClassName="active" to="/devices" title="Digital Twin">
                                    <div className="icon"><DashboardOutlined /></div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Digital Twin</div>
                                </NavLink>
                                :
                                <NavLink className="link" activeClassName="active" to="/schematics" title="Digital Twin">
                                    <div className="icon"><DashboardOutlined /></div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Digital Twin</div>
                                </NavLink>
                        } */}
                        {/* Digital twin */}
                            {pathNameLink === '/schematics' || pathNameLink === '/stats' || pathNameLink === '/devices' ?
                                <NavLink className="link" activeClassName="active" to="/schematics" title="Digital Twin" style={{background: '#1998f0'}}>
                                    <div className="icon">
                                        <img src={activeSchematics} alt="" />
                                    </div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis text-white"> Digital Twin</div>
                                </NavLink>
                                :
                                <NavLink className="link" activeClassName="active" to="/schematics" title="Digital Twin">
                                    <div className="icon">
                                         <img src={schematics} alt="" /></div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Digital Twin</div>
                                </NavLink>
                            }
                        {/* end */}
                        {/* <NavLink className="link" activeClassName="active" to="/alert#/action-2" title=" Reports and Alerts">
                            <div className="icon"><CheckCircleOutlined /></div>
                            <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Reports and Alerts  </div>
                        </NavLink> */}
                        {/* reports and alerts */}
                            {pathNameLink === '/alert' || pathNameLink === '/notificationss' || pathNameLink === '/outliers' ?
                                <NavLink className="link" activeClassName="active" to="/alert" title="Reports and Alerts" style={{background: '#1998f0'}}>
                                    <div className="icon">
                                        <img src={activeMiscellaneous} alt="" />
                                    </div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis text-white"> Reports and Alerts</div>
                                </NavLink>
                                :
                                <NavLink className="link" activeClassName="active" to="/alert" title="Reports and Alerts">
                                    <div className="icon"> <img src={miscellaneous} alt="" /></div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Reports and Alerts</div>
                                </NavLink>
                            }
                        {/*  */}
                        {/* {pathNameLink === '/settings' ?
                            <NavLink className="link" activeClassName="active" to="/settings" title="Setting">
                                <div className="icon">
                                    <img src={activeAccountSettings} alt="" />
                                </div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Account Setting</div>
                            </NavLink>
                            :
                            <NavLink className="link" activeClassName="active" to="/settingsuser" title="Account Settings">
                                <div className="icon"> <img src={accountSettings} alt="" /></div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Account Settings</div>
                            </NavLink>
                        } */}
                        {pathNameLink === '/settings' || pathNameLink === '/settingsuser' || pathNameLink === '/list' || pathNameLink === '/accountnames' || pathNameLink === '/registration' || pathNameLink === '/metermanagement' ?
                            <NavLink className="link" activeClassName="active" to="/settingsuser" title="Setting" style={{background: '#1998f0'}}>
                                <div className="icon">
                                    <img src={ActiveSettings} alt="" />
                                </div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis text-white"> Account Setting</div>
                            </NavLink>
                            :
                            <NavLink className="link" activeClassName="active" to="/settingsuser" title="Account Settings">
                                <div className="icon"> <img src={ActSettings} alt="" /></div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Account Settings</div>
                            </NavLink>
                        }


                       
                        </> :
                        <>
                            <div className="top_section">
                                <div style={{ display: isOpen ? "block" : "none" }} className="logo"> {window.location.hostname === "mizusmart.com" ? <img src={logoImgs} className="img-fluid" alt="McCord Logo Image" /> : <img src={logoImg} className="img-fluid" alt="McCord Logo Image" />} </div>
                                <div style={{ marginLeft: isOpen ? "15px" : "0px" }} className="bars">
                                    <FaBars onClick={toggle} />
                                </div>
                            </div>
                          {/* new */}
                             {/* home */}
                          {pathNameLink === '/dashboard' ?
                                <NavLink className="link" activeClassName="active" to="/dashboard" title="Home" style={{background: '#1998f0'}}>
                                    <div className="icon">
                                        <img src={activeHome} alt="" />
                                    </div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis text-white"> Home</div>
                                </NavLink>
                                :
                                <NavLink className="link" activeClassName="active" to="/dashboard" title="Home">
                                    <div className="icon">
                                         <img src={home} alt="" /></div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Home</div>
                                </NavLink>
                            }
                        {/* home */}
                             {/* Waters */}
                         {pathNameLink === '/Waters' || pathNameLink === '/Wateragg' || pathNameLink === '/watermeterreadings' ?
                                <NavLink className="link" activeClassName="active" to="/Waters" title="Water Usage" style={{background: '#1998f0'}}>
                                    <div className="icon">
                                        <img src={activeUsage} alt="" />
                                    </div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis text-white"> Water Usage</div>
                                </NavLink>
                                :
                                <NavLink className="link" activeClassName="active" to="/Waters" title="Water Usage">
                                    <div className="icon">
                                         <img src={usage} alt="" /></div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Water Usage</div>
                                </NavLink>
                            }
                        {/* Waters */}
                             {/* Analytics */}
                         {pathNameLink === '/totalflow' || pathNameLink === '/predictiveanalysis' || pathNameLink === '/Anomaly' ?
                                <NavLink className="link" activeClassName="active" to="/totalflow" title="Analytics" style={{background: '#1998f0'}}>
                                    <div className="icon">
                                        <img src={activeAnalytics} alt="" />
                                    </div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis text-white"> Analytics</div>
                                </NavLink>
                                :
                                <NavLink className="link" activeClassName="active" to="/totalflow" title="Analytics">
                                    <div className="icon">
                                         <img src={analytics} alt="" /></div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Analytics</div>
                                </NavLink>
                            }
                        {/* Analytics */}
                             {/* reports and alerts */}
                             {pathNameLink === '/alert' || pathNameLink === '/notificationss' || pathNameLink === '/outliers' ?
                                <NavLink className="link" activeClassName="active" to="/alert" title="Reports and Alerts" style={{background: '#1998f0'}}>
                                    <div className="icon">
                                        <img src={activeMiscellaneous} alt="" />
                                    </div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis text-white"> Reports and Alerts</div>
                                </NavLink>
                                :
                                <NavLink className="link" activeClassName="active" to="/alert" title="Reports and Alerts">
                                    <div className="icon"> <img src={miscellaneous} alt="" /></div>
                                    <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Reports and Alerts</div>
                                </NavLink>
                            }
                        {/*  */}
                        {pathNameLink === '/accountnames' ?
                           
                            <NavLink className="link" activeClassName="active" to="/accountnames" title="Account Settings">
                                <div className="icon"> <img src={ActiveSettings} alt="" /></div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Account Settings</div>
                            </NavLink>:   <NavLink className="link" activeClassName="active" to="/accountnames" title="Account Settings">
                                <div className="icon"> <img src={ActSettings} alt="" /></div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Account Settings</div>
                            </NavLink>
                        }
                        


                        {/* end new */}
                          {/* old code */}
                            {/* <NavLink className="link" activeClassName="active" to="/dashboard" title="Home">
                                <div className="icon"><FaHome /></div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Home</div>
                            </NavLink>

                            <NavLink className="link" activeClassName="active" to="/Waters" title="Water Usage">
                                <div className="icon"><AntCloudOutlined /></div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Water Usage</div>
                            </NavLink>
                          
                            <NavLink className="link" activeClassName="active" to="/totalflow" title="Flow Analytics">
                                <div className="icon"><RiseOutlined /></div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Flow Analytics</div>
                            </NavLink>
                           
                            <NavLink className="link" activeClassName="active" to="/predictiveanalysis" title="Predictive Analysis">
                                <div className="icon"><AiOutlineDotChart /></div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Predictive Analysis</div>
                            </NavLink>
                            <NavLink className="link" activeClassName="active" to="/Anomaly" title="Anomaly">
                                <div className="icon"><BugOutlined /></div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Anomaly</div>
                            </NavLink>
                            <NavLink className="link" activeClassName="active" to="/outliers" title="Data Outliers">
                                <div className="icon"><CheckCircleOutlined /></div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Data Outliers</div>
                            </NavLink>

                          
                            <NavLink className="link" activeClassName="active" to="/accountnames" title="Accounts">
                                <div className="icon"><TeamOutlined /></div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Accounts</div>
                            </NavLink>



                            <NavLink className="link" activeClassName="active" to="/notificationss" title="Notification">
                                <div className="icon"><BellOutlined /></div>
                                <div style={{ display: isOpen ? "block" : "none" }} className="link_text text-ellipsis"> Notification</div>
                            </NavLink>*/}
                            
                            </> 
                    }
                </div>

              
            </div>
        </div>
    );
};

export default Sidenav;
